import React, { useEffect, useState } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Polyline,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { PlusIcon } from "../shared/assets/icons";
import GlobalButton from "../shared/utils/GlobalButton";
import L from "leaflet";
import { renderToString } from "react-dom/server";
import { geolib, getDistance } from "geolib";
import axios from "axios";

const MapView = () => {
  const [clusterView, SetClusterView] = useState(false);
  const [locations, setLocations] = useState([]);
  const [clusterLocations, setClusterLocations] = useState();
  useEffect(() => {
    if (locations) {
      createClusters();
    }
  }, []);

  const createClusters = async () => {
    try {
      const token = localStorage.getItem("token");
      const responseFromClusterAPI = await axios.post(
        `${process.env.REACT_APP_URL}/batchOfJobs/assignClusters`,
        { locationsToCreateClusters: locations, minLimitOfJobsInCluster: 4 },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setClusterLocations(responseFromClusterAPI?.data?.clusters);
    } catch (error) {
      console.error("Error in creating clusters:", error);
    }
  };
  function calculateDistance(center, job) {
    return getDistance(
      { latitude: center.latitude, longitude: center.longitude },
      {
        latitude: job.geometry.coordinates[0],
        longitude: job.geometry.coordinates[1],
      },
    );
  }

  const createGreenCustomIcon = (location) =>
    L.divIcon({
      html: `<div>${renderToString(
        <PlusIcon
          color={location.amenity === "restaurant" ? "blue" : "green"}
          size="14"
        />,
      )}</div>`,
      //   className: "custom-icon", // Custom styling class
      iconSize: [14, 14],
    });
  const createRedCustomIcon = (location) =>
    L.divIcon({
      html: `<div>${renderToString(
        <PlusIcon
          color={location.amenity === "restaurant" ? "black" : "red"}
          size="20"
        />,
      )}</div>`,
      //   className: "custom-icon", // Custom styling class
      iconSize: [20, 20],
    });

  return (
    <div>
      <GlobalButton size="small" onClick={() => SetClusterView(!clusterView)}>
        Change view
      </GlobalButton>

      {!clusterView ? (
        <div className="mt-40">
          <h3>locations</h3>

          <MapContainer
            center={[28.6139, 77.209]}
            zoom={12}
            style={{ height: "100vh", width: "100%" }}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
            />
            {locations?.map((job) => (
              <Marker
                key={job.id}
                position={[
                  job.geometry.coordinates[1],
                  job.geometry.coordinates[0],
                ]}
                icon={createGreenCustomIcon(job)}
              >
                <Popup>{job.name}</Popup>
              </Marker>
            ))}
          </MapContainer>
        </div>
      ) : (
        <div className="mt-40">
          <h3>clusters</h3>
          <MapContainer
            center={[28.6139, 77.209]}
            zoom={12}
            style={{ height: "100vh", width: "100%" }}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
            />
            {clusterLocations?.map((location, index) => (
              <Marker
                key={index}
                position={[location.center.longitude, location.center.latitude]}
                icon={createRedCustomIcon(location)}
              >
                <Popup>
                  {"Center: "}
                  {location.id}
                </Popup>
              </Marker>
            ))}
            {clusterLocations?.map((location) =>
              location.jobs.map((job) => {
                const distance = calculateDistance(location.center, job);
                return (
                  <>
                    <Marker
                      key={job.id}
                      position={[
                        job.geometry.coordinates[1],
                        job.geometry.coordinates[0],
                      ]}
                      icon={createGreenCustomIcon(job)}
                    >
                      <Popup>
                        {job.name},{location.id}
                        <br /> Distance to center:{" "}
                        {(distance / 1000).toFixed(2)} km
                      </Popup>
                    </Marker>
                    {/* Draw a line to the cluster center */}
                    <Polyline
                      positions={[
                        [location.center.longitude, location.center.latitude],
                        [
                          job.geometry.coordinates[1],
                          job.geometry.coordinates[0],
                        ],
                      ]}
                      color="blue"
                      weight={2}
                    />
                  </>
                );
              }),
            )}
          </MapContainer>
        </div>
      )}
    </div>
  );
};

export default MapView;
